export default __webpack_public_path__ + "7a6bf76aa22b6acbba35a2c5354e9f75.woff2";